import { IWidget } from "@/types/map";
import { loadModules } from "esri-loader";
import MeasurementDiv from "@/plugin/gis-viewer/widgets/WidgetsManager/MeasurementDiv.vue";
import { Vue } from "vue-property-decorator";
// import { removeData, type } from "jquery";

export default class WidgetsManager {
  private view!: __esri.MapView;
  private static intances: Map<string, WidgetsManager>;

  public measurementTool!: __esri.Measurement;

  private constructor(view: __esri.MapView) {
    this.view = view;
  }
  public static getInstance(view: __esri.MapView) {
    const id = view.container.id;
    if (!WidgetsManager.intances) {
      WidgetsManager.intances = new Map();
    }
    let instance = WidgetsManager.intances.get(id);
    if (!instance) {
      instance = new WidgetsManager(view);
      WidgetsManager.intances.set(id, instance);
    }
    return instance;
  }
  public async initWidgets(params: Array<IWidget>) {
    type MapModules = [
      typeof import("esri/layers/GraphicsLayer"),
      typeof import("esri/widgets/Sketch"),
      typeof import("esri/widgets/Measurement"),
      typeof import("esri/widgets/Search"),
      typeof import("esri/widgets/Locate"),
      typeof import("esri/widgets/CoordinateConversion"),
      typeof import("esri/widgets/Zoom")
    ];
    const [
      GraphicsLayer,
      Sketch,
      Measurement,
      Search,
      Locate,
      CoordinateConversion,
      Zoom
    ] = await (loadModules([
      "esri/layers/GraphicsLayer",
      "esri/widgets/Sketch",
      "esri/widgets/Measurement",
      "esri/widgets/Search",
      "esri/widgets/Locate",
      "esri/widgets/CoordinateConversion",
      "esri/widgets/Zoom"
    ]) as Promise<MapModules>);

    let widgets: Array<IWidget> = params;

    widgets.forEach((widget) => {
      let tool: any;
      let position = "top-left";
      let relativePos: any;
      let divPos: any;
      let measureDiv: any = undefined;
      let defaultVisible = widget.visible !== false;
      switch (widget.name) {
        case "zoom":
          tool = new Zoom({ view: this.view });
          break;
        case "draw":
          let sketchLayer = new GraphicsLayer();
          this.view.map.add(sketchLayer);
          tool = new Sketch({
            layer: sketchLayer,
            view: this.view,
            // graphic will be selected as soon as it is created
            creationMode: "update"
          });
          tool.on("update", (event: any) => {
            //if (event.state === "complete") {
            const graphic = event.graphics[0];
            if (graphic.geometry.type == "polyline") {
              graphic.symbol = {
                type: "simple-line", // autocasts as SimpleLineSymbol()
                color: [0, 255, 0],
                style: "solid",
                width: 2
              };
            } else if (graphic.geometry.type == "polygon") {
              graphic.symbol = {
                type: "simple-fill", // autocasts as new SimpleFillSymbol()
                color: [0, 191, 255, 0.3],
                style: "solid",
                outline: {
                  // autocasts as new SimpleLineSymbol()
                  color: [255, 0, 0, 1],
                  style: "solid",
                  width: 3
                }
              };
            } else if (graphic.geometry.type == "point") {
              graphic.symbol = {
                type: "simple-marker", // autocasts as new SimpleFillSymbol()
                color: [255, 0, 0],
                style: "circle",
                size: 10,
                outline: {
                  // autocasts as new SimpleLineSymbol()
                  color: [255, 255, 255],
                  style: "solid",
                  width: 1.5
                }
              };
            }
            //}
          });
          position = "top-right";
          break;
        case "measure":
          //测线工具
          tool = new Measurement({ view: this.view });
          this.measurementTool = tool;
          let vm = new Vue({
            // 为什么不使用 template 要使用render 因为现在是webpack里面没有编译器 只能使用render
            render: (h) =>
              h(MeasurementDiv, { props: { measurementTool: tool } } as any) // render 生成虚拟dom  {props: props}
          }).$mount(); // $mount 生成真实dom, 挂载dom 挂载在哪里, 不传参的时候只生成不挂载，需要手动挂载
          measureDiv = vm.$el as HTMLElement;
          measureDiv.id = "measure";
          break;
        case "locate":
          //定位工具
          tool = new Locate({
            view: this.view
          });
          // Add the locate widget to the top left corner of the view
          break;
        case "search":
          //搜索工具
          tool = new Search({
            view: this.view
          });
          break;
        case "coordinate":
          //坐标工具
          tool = new CoordinateConversion({
            view: this.view
          });
          position = "bottom-left";
          break;
      }
      tool.id = widget.name === "measure" ? "measureDiv" : widget.name;
      if (widget.config && widget.config.position) {
        if (typeof widget.config.position == "string") {
          position = widget.config.position;
        } else {
          position = "manual";
          relativePos = widget.config.position;
          if (widget.config.divPosition) {
            divPos = widget.config.divPosition;
          }
        }
      }
      if (measureDiv) {
        //测距工具
        this.view.ui.add(measureDiv, position);
        if (!defaultVisible) {
          measureDiv.style.display = "none";
        }
      }

      this.view.ui.add(tool, position);
      if (!defaultVisible && widget.name !== "measure") {
        tool.container.style.display = "none";
      }

      if (relativePos) {
        //let left = Number(relativePos.left.toString().replace("px", ""));
        if (measureDiv) {
          measureDiv.style.left = relativePos.left || "";
          measureDiv.style.right = relativePos.right || "";
          measureDiv.style.top = relativePos.top || "";
          measureDiv.style.bottom = relativePos.bottom || "";
        }
        if (widget.name == "measure") {
          if (divPos) {
            tool.container.style.left = divPos.left || "";
            tool.container.style.right = divPos.right || "";
            tool.container.style.top = divPos.top || "";
            tool.container.style.bottom = divPos.bottom || "";
          } else {
            if (relativePos.top) {
              tool.container.style.top =
                Number(relativePos.top.replace("px", "")) + 40 + "px";
            } else if (relativePos.bottom) {
              tool.container.style.bottom =
                Number(relativePos.bottom.replace("px", "")) + 40 + "px";
            } else {
              tool.container.style.top = "40px";
            }
          }
        } else {
          tool.container.style.top = relativePos.top || "";
          tool.container.style.bottom = relativePos.bottom || "";
        }
        tool.container.style.left = relativePos.left || "";
        tool.container.style.right = relativePos.right || "";
      }
    });
  }
  public async toggleWidget(widgetNames: string[] | string) {
    let widgets: string[] =
      typeof widgetNames === "string" ? [widgetNames] : widgetNames;
    widgets.forEach((widgetName) => {
      let widget: any = this.view.ui.find(widgetName);
      if (widget) {
        let el: any = widget.container || widget;
        if (el.style.display == "none") {
          el.style.display = "flex";
        } else {
          if (widget.id == "measure") {
            this.measurementTool.clear();
          }
          el.style.display = "none";
        }
      }
    });
  }
  public async setWidgetPos(widgets: Array<IWidget>) {
    if (widgets && widgets.length > 0) {
      widgets.forEach((item) => {
        let widget: any = this.view.ui.find(item.name);
        if (widget) {
          let el: any = widget.container || widget;
          let relativePos = item.config.position;
          let divPos = item.config.divPosition;
          el.style.left = relativePos.left || "";
          el.style.right = relativePos.right || "";
          el.style.top = relativePos.top || "";
          el.style.bottom = relativePos.bottom || "";
          if (item.name == "measure" && divPos && this.measurementTool) {
            let tool: any = this.measurementTool;
            tool.container.style.left = divPos.left || "";
            tool.container.style.right = divPos.right || "";
            tool.container.style.top = divPos.top || "";
            tool.container.style.bottom = divPos.bottom || "";
          }
        }
      });
    }
  }
}
